import { Trans, useTranslation } from '@e-kyc/translations';

import { WarningRoundedOutlinedIcon } from '../../components';

export interface ErrorPageProps {
  title?: string;
  description?: string;
}

export default function ErrorPage({ title, description }: ErrorPageProps) {
  const { t } = useTranslation();
  const renderedTitle = title ? t(title) : t('token.error.expired.title');

  return (
    <div className='flex h-dvh w-full flex-col items-center justify-center'>
      <div className='flex size-full flex-col items-center justify-center gap-4 p-4'>
        <WarningRoundedOutlinedIcon className='text-warning size-14' />
        <div className='flex flex-col items-center justify-center gap-2'>
          <h5 className='text-text-primary font-semibold'>{renderedTitle}</h5>
          <div className='text-body-1 text-text-secondary h-18 text-center'>
            <Trans i18nKey={description ?? 'token.error.expired.description'} />
          </div>
        </div>
      </div>
    </div>
  );
}
